export default "__VITE_ASSET__BtvVLujD__"